document.addEventListener('DOMContentLoaded', function () {
  const shipInput = document.querySelector('input[name="properties[Schiff]"]');
  const startInput = document.querySelector('input[name="properties[Reise-Startdatum]"]');
  const endInput = document.querySelector('input[name="properties[Reise-Enddatum]"]');
  const orientationInputs = document.querySelectorAll('input[name="properties[Ausrichtung]"]');

  const shipError = document.querySelector('[id^="schiff-fehler-"]');
  const startError = document.querySelector('[id^="start-fehler-"]');
  const endError = document.querySelector('[id^="end-fehler-"]');

  if (!shipInput || !startInput || !endInput) {
    return;
  }

  const formId = shipInput.getAttribute('form');
  const form = formId ? document.getElementById(formId) : null;

  if (!form) {
    return;
  }

  const listId = shipInput.getAttribute('list');
  const datalist = listId ? document.getElementById(listId) : null;

  const allowedShips = datalist
    ? Array.from(datalist.querySelectorAll('option'))
        .map(function (option) {
          return option.value.trim();
        })
        .filter(Boolean)
    : [];

  const touched = {
    ship: false,
    start: false,
    end: false
  };

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.style.display = 'block';
  }

  function clearError(el) {
    if (!el) return;
    el.textContent = '';
    el.style.display = 'none';
  }

  function markInvalid(input, invalid) {
    if (!input) return;
    input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    input.style.borderColor = invalid ? '#b42318' : '';
  }

  function anyOrientationSelected() {
    return Array.from(orientationInputs).some(function (input) {
      return input.checked;
    });
  }

  function validateShip() {
    const value = shipInput.value.trim();

    if (!value) {
      if (touched.ship) {
        showError(shipError, 'Bitte ein Schiff auswählen.');
        markInvalid(shipInput, true);
      } else {
        clearError(shipError);
        markInvalid(shipInput, false);
      }
      return false;
    }

    const normalizedValue = value.toLowerCase().trim();

    const isValid = allowedShips.some(function (ship) {
      return ship.toLowerCase().trim() === normalizedValue;
    });

    if (!isValid) {
      if (touched.ship) {
        showError(shipError, 'Bitte ein Schiff aus der Liste auswählen.');
        markInvalid(shipInput, true);
      } else {
        clearError(shipError);
        markInvalid(shipInput, false);
      }
      return false;
    }

    clearError(shipError);
    markInvalid(shipInput, false);
    return true;
  }

  function validateStart() {
    if (!startInput.value) {
      if (touched.start) {
        showError(startError, 'Bitte ein Startdatum auswählen.');
        markInvalid(startInput, true);
      } else {
        clearError(startError);
        markInvalid(startInput, false);
      }
      return false;
    }

    clearError(startError);
    markInvalid(startInput, false);
    return true;
  }

  function validateEnd() {
    if (!endInput.value) {
      if (touched.end) {
        showError(endError, 'Bitte ein Enddatum auswählen.');
        markInvalid(endInput, true);
      } else {
        clearError(endError);
        markInvalid(endInput, false);
      }
      return false;
    }

    if (startInput.value && endInput.value < startInput.value) {
      if (touched.end) {
        showError(endError, 'Das Enddatum darf nicht vor dem Startdatum liegen.');
        markInvalid(endInput, true);
      } else {
        clearError(endError);
        markInvalid(endInput, false);
      }
      return false;
    }

    clearError(endError);
    markInvalid(endInput, false);
    return true;
  }

  function validateAll() {
    const okOrientation = anyOrientationSelected();
    const okShip = validateShip();
    const okStart = validateStart();
    const okEnd = validateEnd();

    return okOrientation && okShip && okStart && okEnd;
  }

  function updateSubmitState() {
    const isValid = validateAll();
    const submitButton = form.querySelector('button[type="submit"][name="add"]');

    if (submitButton) {
      submitButton.disabled = !isValid;
      submitButton.setAttribute('aria-disabled', (!isValid).toString());
    }

    return isValid;
  }

  if (startInput.value) {
    endInput.min = startInput.value;
  }

  shipInput.addEventListener('focus', function () {
    touched.ship = true;
  });

  startInput.addEventListener('focus', function () {
    touched.start = true;
  });

  endInput.addEventListener('focus', function () {
    touched.end = true;
  });

  shipInput.addEventListener('input', function () {
    updateSubmitState();
  });

  shipInput.addEventListener('change', function () {
    updateSubmitState();
  });

  shipInput.addEventListener('blur', function () {
    updateSubmitState();
  });

  startInput.addEventListener('input', function () {
    endInput.min = startInput.value || '';
    updateSubmitState();
  });

  startInput.addEventListener('change', function () {
    endInput.min = startInput.value || '';
    updateSubmitState();
  });

  startInput.addEventListener('blur', function () {
    updateSubmitState();
  });

  endInput.addEventListener('input', function () {
    updateSubmitState();
  });

  endInput.addEventListener('change', function () {
    updateSubmitState();
  });

  endInput.addEventListener('blur', function () {
    updateSubmitState();
  });

  orientationInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      updateSubmitState();
    });
  });

  form.addEventListener('submit', function (event) {
    touched.ship = true;
    touched.start = true;
    touched.end = true;

    if (!validateAll()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      updateSubmitState();
    }
  }, true);

  updateSubmitState();
});